export interface MemedWorkplacePayload {
  city?: string;
  state?: string;
  cnes?: string;
  local_name?: string;
  address?: string;
  phone?: string;
}

export interface MemedWorkplaceConfig {
  city?: string | null;
  state?: string | null;
  cnes?: string | null;
  local_name?: string | null;
  address?: string | null;
  phone?: string | null;
}

const WORKPLACE_FIELDS = ['city', 'state', 'cnes', 'local_name', 'address', 'phone'] as const;

export function buildMemedWorkplace(config?: MemedWorkplaceConfig): MemedWorkplacePayload | undefined {
  if (!config) {
    return undefined;
  }

  const payload: MemedWorkplacePayload = {};

  for (const field of WORKPLACE_FIELDS) {
    const value = config[field];
    if (typeof value === 'string' && value.trim() !== '') {
      payload[field] = value;
    }
  }

  return Object.keys(payload).length > 0 ? payload : undefined;
}
